'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';
import {
    SET_FUNCTIONS_PROFILE_TO_USER,
    GET_DATA_USERS_PROFILE_TO_USER_START,
    GET_DATA_USERS_PROFILE_TO_USER_SUCCESS,
    SEARCH_USERS_TO_PROFILE,
    SET_ACTIVOS_CHECKBOX_USERS_TO_PROFILE,
    SET_BLOQUEADOS_CHECKBOX_USERS_TO_PROFILE,
    SET_ELIMINADOS_CHECKBOX_USERS_TO_PROFILE,
    SET_ALL_CHECKBOX_USERS_TO_PROFILE,
    FILTER_ORDER_COLUMN_USERS_TO_PROFILE,
    FILTER_CHECKBOX_USERS_TO_PROFILE,
    INITIAL_STATE_USERS_TO_PROFILE,
    SET_TITLE_USERS_TO_PROFILE,
    DO_TRANSACTION_ASIGNAR_PERFIL_SUCCESS,
    DO_TRANSACTION_ASIGNAR_PERFIL_FAILED,
    DO_TRANSACTION_ASIGNAR_PERFIL_START,
    ESCONDER_POPUP_ASIGNARPERFILAUSUARIO
} from '../../Screens/AsignarPerfilAUsuario/actions/AsignarPerfilAUsuario';

const initialState = {
    currentUser: null,
    isFetching: true,
    redirect: false,
    title2: undefined,
    functions: [],
    usuarios: undefined,
    usuariosFiltrados: undefined,
    usuariosSeleccionados: [],
    searchFilter: "",
    activoFilter: true,
    bloqueadoFilter: true,
    eliminadoFilter: true,
    allCheckboxFilter: false,
    column: [{ "name": "nombre", "state": false }, { "name": "login", "state": true }, { "name": "sucursal", "state": true }, { "name": "sector", "state": true }],
    columnIndex: 0,
    isCurrentUser: undefined,
    message: "",
    messageClass: "",
    messageHidden: true
};

function asignarPerfilAUsuario(state = initialState, action) {
    LogHelper.In(asignarPerfilAUsuario.name, state, action);

    let result;
    let usuariosFiltrados, usuariosTemp, temp = null;
    let usuariosSeleccionadosTemp = [];

    switch (action.type) {

        case SET_FUNCTIONS_PROFILE_TO_USER:
            LogHelper.In(asignarPerfilAUsuario.name, state, action);

            result = {
                ...state,
                functions: action.functions
            };
            break;

        case GET_DATA_USERS_PROFILE_TO_USER_START:
            LogHelper.In(asignarPerfilAUsuario.name, state, action);

            result = {
                ...state,
                currentUser: action.currentUser,
                isFetching: true
            };
            break;

        case GET_DATA_USERS_PROFILE_TO_USER_SUCCESS:
            LogHelper.In(asignarPerfilAUsuario.name, state, action);

            let tempResult = action.result;            
            tempResult.forEach(p => { p.Seleccionado = false; });
            let usuariosSeleccionados = [];

             if (sessionStorage.getItem("usuariosSeleccionados") != null){
                usuariosSeleccionados = JSON.parse(sessionStorage.usuariosSeleccionados);
                tempResult.forEach(function(usr) {
                    usuariosSeleccionados.forEach(function(sel) {
                        if(usr.Id == sel.Id){
                            usr.Seleccionado = true;
                        }
                    })
                });                
                 sessionStorage.removeItem("usuariosSeleccionados")
             }

            result = {
                ...state,
                isFetching: false,
                usuarios: tempResult,
                usuariosFiltrados: tempResult,
                usuariosSeleccionados: usuariosSeleccionados
            };
            break;

        case SET_TITLE_USERS_TO_PROFILE:
            LogHelper.In(asignarPerfilAUsuario.name, state, action);

            let _title2 = action._title2[0].Codigo;

            result = {
                ...state,
                title2: _title2
            };

            break;

        case SEARCH_USERS_TO_PROFILE:
            LogHelper.In(asignarPerfilAUsuario.name, state, action);

            usuariosFiltrados = usuariosFilter(state, action.user, null, null, null, null, null, null);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                searchFilter: action.user
            };
            break;

        case SET_ACTIVOS_CHECKBOX_USERS_TO_PROFILE:
            LogHelper.In(asignarPerfilAUsuario.name, state, action);

            usuariosFiltrados = usuariosFilter(state, null, action.activo, null, null, null, null, null);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                activoFilter: action.activo
            };
            break;

        case SET_BLOQUEADOS_CHECKBOX_USERS_TO_PROFILE:
            LogHelper.In(asignarPerfilAUsuario.name, state, action);

            usuariosFiltrados = usuariosFilter(state, null, null, action.bloqueado, null, null, null, null);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                bloqueadoFilter: action.bloqueado
            };
            break;

        case SET_ELIMINADOS_CHECKBOX_USERS_TO_PROFILE:
            LogHelper.In(asignarPerfilAUsuario.name, state, action);

            usuariosFiltrados = usuariosFilter(state, null, null, null, action.eliminado, null, null, null);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                eliminadoFilter: action.eliminado
            };
            break;

        case FILTER_ORDER_COLUMN_USERS_TO_PROFILE:
            LogHelper.In(asignarPerfilAUsuario.name, state, action);

            let columnTemp = JSON.parse(JSON.stringify(state.column));
            columnTemp[action.columnIndex].state = !columnTemp[action.columnIndex].state;

            usuariosFiltrados = usuariosFilter(state, null, null, null, null, action.columnIndex, columnTemp, null);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                columnIndex: action.columnIndex,
                column: columnTemp
            };
            break;

        case SET_ALL_CHECKBOX_USERS_TO_PROFILE:
            LogHelper.In(asignarPerfilAUsuario.name, state, action);

            let usuariosTemp = JSON.parse(JSON.stringify(state.usuarios));
            let usuariosSeleccionadosTemp = JSON.parse(JSON.stringify(state.usuariosSeleccionados));

            if (action.allCheckboxFilter == true) {
                usuariosTemp.forEach(function (item) {
                    if (action.currentUser != item.Id)
                        usuariosSeleccionadosTemp.push(item);
                })
            } else {
                usuariosSeleccionadosTemp = [];
            }

            usuariosFiltrados = usuariosFilter(state, null, null, null, null, null, null, usuariosSeleccionadosTemp);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                usuariosSeleccionados: usuariosSeleccionadosTemp,
                allCheckboxFilter: action.allCheckboxFilter
            };
            break;

        case FILTER_CHECKBOX_USERS_TO_PROFILE:
            LogHelper.In(asignarPerfilAUsuario.name, state, action);

            usuariosTemp = JSON.parse(JSON.stringify(state.usuarios));
            usuariosSeleccionadosTemp = JSON.parse(JSON.stringify(state.usuariosSeleccionados));

            let temp = usuariosSeleccionadosTemp.find(x => x.Id == action.usuarioId);
            if (temp != undefined) {
                usuariosSeleccionadosTemp.forEach(function (item, index, object) {
                    if (item.Id == action.usuarioId)
                        object.splice(index, 1);
                })
            } else {
                usuariosTemp.forEach(function (item) {
                    if (item.Id == action.usuarioId)
                        usuariosSeleccionadosTemp.push(item);
                })
            }

            usuariosFiltrados = usuariosFilter(state, null, null, null, null, null, null, usuariosSeleccionadosTemp);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                usuariosSeleccionados: usuariosSeleccionadosTemp
            };
            break;

        case INITIAL_STATE_USERS_TO_PROFILE:
            result = initialState;
            break;

        case DO_TRANSACTION_ASIGNAR_PERFIL_SUCCESS:
            LogHelper.In(asignarPerfilAUsuario.name, state, action); 

            result = {
                ...state,
                redirect: true,
                message: "",
                messageClass: "",
                messageHidden: false
            };  

            break;

        case DO_TRANSACTION_ASIGNAR_PERFIL_FAILED:
            LogHelper.In(asignarPerfilAUsuario.name, state, action); 

            result = {
                ...state,
                redirect: false,
                message: "Error al intentar asignar los perfiles seleccionados al usuario.",
                messageClass: "error",
                messageHidden: false
            };  
            break;

        case DO_TRANSACTION_ASIGNAR_PERFIL_START:
            LogHelper.In(asignarPerfilAUsuario.name, state, action); 

            result = {
                ...state
            };  
            break;

        case ESCONDER_POPUP_ASIGNARPERFILAUSUARIO:
            LogHelper.In(asignarPerfilAUsuario.name, action, state);

            result = {
                ...state,
                message: "",
                messageClass: "",
                messageHidden: true
            };

            break;

        default:
            LogHelper.In(asignarPerfilAUsuario.name, state, action);
            result = {
                ...state
            }
            break;
    }

    LogHelper.Out(asignarPerfilAUsuario.name, result);
    return result;
}

export default asignarPerfilAUsuario;


/**
 * Funcion general de filtrado que realiza (busqueda por nombre, por filtros y ordenamiento de columnas ascendente y descendente).
 * @param {any} state
 * @param {any} searchFilter
 * @param {any} activoFilter
 * @param {any} bloqueadoFilter
 * @param {any} eliminadoFilter
 * @param {any} columnIndex
 * @param {any} column
 * @param {any} usuariosSeleccionados
 */
function usuariosFilter(state, searchFilter, activoFilter, bloqueadoFilter, eliminadoFilter, columnIndex, column, usuariosSeleccionados) {
    LogHelper.In(usuariosFilter.name);

    //Obtengo valores y si no los recibi por parametro uso los que ya existen en el state.
    let usuariosFiltrados = JSON.parse(JSON.stringify(state.usuarios));

    searchFilter = searchFilter != null ? searchFilter : state.searchFilter;
    activoFilter = activoFilter != null ? activoFilter : state.activoFilter;
    bloqueadoFilter = bloqueadoFilter != null ? bloqueadoFilter : state.bloqueadoFilter;
    eliminadoFilter = eliminadoFilter != null ? eliminadoFilter : state.eliminadoFilter;
    columnIndex = columnIndex != null ? columnIndex : state.columnIndex;
    column = column != null ? column : state.column;
    usuariosSeleccionados = usuariosSeleccionados != null ? usuariosSeleccionados : state.usuariosSeleccionados;

    //Filtro por nombre de usuario.
    if (searchFilter != "")
        usuariosFiltrados = usuariosFiltrados.filter(x => x.Nombre.toUpperCase().includes(searchFilter.toUpperCase())  || x.Login.toUpperCase().includes(searchFilter.toUpperCase()));

    //Filtro por checkboxes de Activo, Bloqueado, Eliminado.
    let filteredRows = [];
    usuariosFiltrados.forEach(function (row) {
        //Activo
        if (activoFilter == true && bloqueadoFilter == false && eliminadoFilter == false) {
            if (row.Activo == true && row.Bloqueado == false) {
                LogHelper.Out(usuariosFilter.name, row);
                filteredRows.push(row);
                return;
            }
        }
        //Bloqueado
        if (activoFilter == false && bloqueadoFilter == true && eliminadoFilter == false) {
            if (row.Activo == false && row.Bloqueado == true) {
                LogHelper.Out(usuariosFilter.name, row);
                filteredRows.push(row);
                return;
            }
        }
        //Eliminado
        if (activoFilter == false && bloqueadoFilter == false && eliminadoFilter == true) {
            if (row.Activo == false && row.Bloqueado == false) {
                LogHelper.Out(usuariosFilter.name, row);
                filteredRows.push(row);
                return;
            }
        }
        //Activo y Bloqueado
        if (activoFilter == true && bloqueadoFilter == true && eliminadoFilter == false) {
            if ((row.Activo == true && row.Bloqueado == false) || (row.Activo == false && row.Bloqueado == true)) {
                LogHelper.Out(usuariosFilter.name, row);
                filteredRows.push(row);
                return;
            }
        }
        //Activo y Eliminado
        if (activoFilter == true && bloqueadoFilter == false && eliminadoFilter == true) {
            if ((row.Activo == true && row.Bloqueado == false) || (row.Activo == false && row.Bloqueado == false)) {
                LogHelper.Out(usuariosFilter.name, row);
                filteredRows.push(row);
                return;
            }
        }
        //Bloqueado y Eliminado
        if (activoFilter == false && bloqueadoFilter == true && eliminadoFilter == true) {
            if ((row.Activo == false && row.Bloqueado == true) || (row.Activo == false && row.Bloqueado == false)) {
                LogHelper.Out(usuariosFilter.name, row);
                filteredRows.push(row);
                return;
            }
        }
        //Activo, Bloqueado y Eliminado
        if (activoFilter == true && bloqueadoFilter == true && eliminadoFilter == true) {
            LogHelper.Out(usuariosFilter.name, row);
            filteredRows.push(row);
            return;
        }

        usuariosFiltrados = filteredRows;
    });

    //Filtro por columna y ejecuto el Sort en cada caso.
    if (column[columnIndex].state == true) {
        usuariosFiltrados = usuariosFiltrados.sort(function (a, b) {
            LogHelper.Out(usuariosFilter.name);
            return sortArray(columnIndex, a, b, -1, 1);
        });
    } else {
        usuariosFiltrados = usuariosFiltrados.sort(function (a, b) {
            LogHelper.Out(usuariosFilter.name);
            return sortArray(columnIndex, a, b, 1, -1);
        });
    }

    
    usuariosFiltrados.forEach(p => { p.Seleccionado = false; });
    //Filtro por checkboxes seleccionados.
    usuariosFiltrados.forEach(function (item) {
        usuariosSeleccionados.forEach(function (item2) {
            if (item.Id == item2.Id)
                item.Seleccionado = true;
        })
    })

    LogHelper.Out(usuariosFilter.name, usuariosFiltrados);

    return usuariosFiltrados;
}


/**
 * Ordena la información de manera ascendente o descendente según los parametros recibidos.
 * @param {any} columnIndex - Indice que indica la columna de la tabla que fue clickeada.
 * @param {any} a
 * @param {any} b
 * @param {any} asc
 * @param {any} desc
 */
function sortArray(columnIndex, a, b, asc, desc) {
    LogHelper.In(sortArray.name);

    let firstRow = "";
    let SecondRow = "";
    switch (columnIndex) {
        case 0:
            firstRow = a.Nombre.toUpperCase();
            SecondRow = b.Nombre.toUpperCase();
            break;
        case 1:
            firstRow = a.Login.toUpperCase();
            SecondRow = b.Login.toUpperCase();
            break;
        case 2:
            firstRow = a.SUCURSAL.toUpperCase();
            SecondRow = b.SUCURSAL.toUpperCase();
            break;
        case 3:
            firstRow = a.SECTOR.toUpperCase();
            SecondRow = b.SECTOR.toUpperCase();
            break;
    }

    if (firstRow > SecondRow) {
        LogHelper.Out(sortArray.name, asc);
        return asc;
    }
    if (firstRow < SecondRow) {
        LogHelper.Out(sortArray.name, desc);
        return desc;
    }

    LogHelper.Out(sortArray.name);

    return 0;
}